/** @jsxImportSource react */
import * as Typeform from '@typeform/embed';
const { createPopup } = Typeform;
import clsxm from '@common/lib/clsxm';
import { usePopups } from '@react/services/popupsContext';
import { Button } from '@react/system';
import { bool, func, object, string } from 'proptypes';
import React, { useEffect, useMemo, useRef } from 'react';

const emptyEmbed = {
  unmount: () => {},
  open: () => {},
};

const TypeformPopupButton = ({
  id,
  className,
  buttonText,
  popupButtonClickHandler,
  disabled,
  sx,
  disabledButtonText = 'Pricing Requested',
  palette = 'viridian',
  variant = 'primary',
  eventProps,
  Icon,
  openByDefault,
  ...props
}) => {
  const ref = useRef(emptyEmbed);
  const { setPopupActive } = usePopups();

  useEffect(() => {
    ref.current = createPopup(id, props); // onSubmit
  }, [id, props.onSubmit, props.hidden]);

  useEffect(() => {
    if (ref.current && openByDefault) {
      handleClick();
    }
  }, [openByDefault]);

  useEffect(() => {
    () => ref.current.unmount();
  }, []);

  const handleClick = useMemo(() => () => ref.current.open(), []);

  const clickHandler = () => {
    handleClick();
    setPopupActive(true);
    if (popupButtonClickHandler) {
      popupButtonClickHandler();
    }
  };

  const buttonWrapperClass = Icon ? 'flex gap-xs justify-center' : '';

  return (
    <>
      <Button
        variant={variant}
        palette={palette}
        onClick={clickHandler}
        className={clsxm(buttonWrapperClass, className)}
        sx={sx}
        disabled={disabled}
        eventProps={eventProps}
        data-tp-id='gen-Button-72b92f76-1f04-4542-b32a-d9bab622847c'
      >
        {props?.children
          ? props.children
          : !disabled
          ? buttonText
          : disabledButtonText}
        {Icon && (
          <Icon data-tp-id='gen-Icon-61bfbc14-e6c5-4eeb-9bcd-b608a113b0b8' />
        )}
      </Button>
    </>
  );
};

TypeformPopupButton.propTypes = {
  id: string.isRequired,
  className: string,
  style: object,
  buttonText: string.isRequired,
  popupButtonClickHandler: func,
  onsubmit: func,
  onSubmit: func,
  disabled: bool,
  sx: object,
  disabledButtonText: string,
  palette: string,
  variant: string,
  eventProps: object,
};

export default TypeformPopupButton;
